/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24/ContainerHome24';
import CustomEmblaCarouselHome24 from '../../organisms/CustomEmblaCarouselHome24';
import Styles from './Home24Carousel.css';
import { isMobile } from '@/utils/browser';

function Home24Carousel() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <section id="santander-carousel">
      <ContainerHome24>
        <div className="santander-carousel-contain">
          <CustomEmblaCarouselHome24
            loop
            enableBullets
            enableMobileArrows
            detectBulletCount
            hideOverflow
            autoplay={8}
          >
            {({ className }) => (
              <>
                <div className={`slide ${className}`}>
                  <a href="energia-solar-fotovoltaica.html" alt="">
                    <div className="bg-banner">
                      {typeof window === 'undefined' ? (
                        <></>
                      ) : (
                        <>
                          {width <= 312 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/energia-solar-v2/banner-312.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/energia-solar-v2/banner-312.png"
                              />
                              <img
                                src="assets/home24/banners/energia-solar-v2/banner-312.png"
                                alt="Placa solar com céu azul com nuvens"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 312 && width <= 414 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/energia-solar-v2/banner-414.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/energia-solar-v2/banner-414.png"
                              />
                              <img
                                src="assets/home24/banners/energia-solar-v2/banner-414.png"
                                alt="Placa solar com céu azul com nuvens"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 414 && width <= 600 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/energia-solar-v2/banner-601.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/energia-solar-v2/banner-601.png"
                              />
                              <img
                                src="assets/home24/banners/energia-solar-v2/banner-601.png"
                                alt="Placa solar com céu azul com nuvens"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 600 && width <= 800 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/energia-solar-v2/banner-800.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/energia-solar-v2/banner-800.png"
                              />
                              <img
                                src="assets/home24/banners/energia-solar-v2/banner-800.png"
                                alt="Placa solar com céu azul com nuvens"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 800 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/energia-solar-v2/banner-1280.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/energia-solar-v2/banner-1280.png"
                              />
                              <img
                                src="assets/home24/banners/energia-solar-v2/banner-1280.png"
                                alt="Placa solar com céu azul com nuvens"
                                className=""
                              />
                            </picture>
                          )}
                        </>
                      )}
                    </div>
                    <div className="conteudo-banner">
                      <h2 className="banner-title">
                        Financie seu sistema de placa solar e economize na conta de luz
                      </h2>
                      <h3 className="banner-subtitle">
                        Faça uma escolha inteligente para o meio ambiente e para o seu bolso.
                      </h3>
                      <p className="banner-saber-mais">Saiba mais</p>
                    </div>
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a href="emprestimo-garantia-carro.html" alt="">
                    <div className="bg-banner">
                      {typeof window === 'undefined' ? (
                        <></>
                      ) : (
                        <>
                          {width <= 312 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/cp-com-garantia/banner-312.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/cp-com-garantia/banner-312.png"
                              />
                              <img
                                src="assets/home24/banners/cp-com-garantia/banner-312.png"
                                alt="Homem branco sentado com computador buscando como realizar um Empréstimo com Garantia de Veículo na Santander Financiamento."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 312 && width <= 414 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/cp-com-garantia/banner-414.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/cp-com-garantia/banner-414.png"
                              />
                              <img
                                src="assets/home24/banners/cp-com-garantia/banner-414.png"
                                alt="Homem branco sentado com computador buscando como realizar um Empréstimo com Garantia de Veículo na Santander Financiamento."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 414 && width <= 600 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/cp-com-garantia/banner-601.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/cp-com-garantia/banner-601.png"
                              />
                              <img
                                src="assets/home24/banners/cp-com-garantia/banner-601.png"
                                alt="Homem branco sentado com computador buscando como realizar um Empréstimo com Garantia de Veículo na Santander Financiamento."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 600 && width <= 800 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/cp-com-garantia/banner-800.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/cp-com-garantia/banner-800.png"
                              />
                              <img
                                src="assets/home24/banners/cp-com-garantia/banner-800.png"
                                alt="Homem branco sentado com computador buscando como realizar um Empréstimo com Garantia de Veículo na Santander Financiamento."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 800 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/cp-com-garantia/banner-1280.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/cp-com-garantia/banner-1280.png"
                              />
                              <img
                                src="assets/home24/banners/cp-com-garantia/banner-1280.png"
                                alt="Homem branco sentado com computador buscando como realizar um Empréstimo com Garantia de Veículo na Santander Financiamento."
                                className=""
                              />
                            </picture>
                          )}
                        </>
                      )}
                    </div>
                    <div className="conteudo-banner">
                      <h2 className="banner-title">Precisando de dinheiro extra?</h2>
                      <h3 className="banner-subtitle">
                        A nova oferta de <b>Empréstimo com Garantia de Veículo</b> chegou! <br />
                        Consiga até <b>R$ 200 mil</b> de forma simples e sem burocracia.
                      </h3>
                      <p className="banner-saber-mais">Simule agora</p>
                    </div>
                  </a>
                </div>
                {/* <div className={`slide ${className}`}>
                  <a
                    href="https://emprestimosim.com.br/boleto-parcelado-pf/?int_source=portalSF&int_medium=home:carrossel:2a-dobra:bens-e-serviços&int_campaign=saiba-mais"
                    target="_blank"
                    alt=""
                  >
                    <div className="bg-banner">
                      {typeof window === 'undefined' ? (
                        <></>
                      ) : (
                        <>
                          {width <= 312 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/bens-e-servicos-v2/banner-312.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/bens-e-servicos-v2/banner-312.png"
                              />
                              <img
                                src="assets/home24/banners/bens-e-servicos-v2/banner-312.png"
                                alt="Sala com sofá, mesa de centro com vaso em cima"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 312 && width <= 414 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/bens-e-servicos-v2/banner-414.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/bens-e-servicos-v2/banner-414.png"
                              />
                              <img
                                src="assets/home24/banners/bens-e-servicos-v2/banner-414.png"
                                alt="Sala com sofá, mesa de centro com vaso em cima"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 414 && width <= 600 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/bens-e-servicos-v2/banner-601.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/bens-e-servicos-v2/banner-601.png"
                              />
                              <img
                                src="assets/home24/banners/bens-e-servicos-v2/banner-601.png"
                                alt="Sala com sofá, mesa de centro com vaso em cima"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 600 && width <= 800 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/bens-e-servicos-v2/banner-800.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/bens-e-servicos-v2/banner-800.png"
                              />
                              <img
                                src="assets/home24/banners/bens-e-servicos-v2/banner-800.png"
                                alt="Sala com sofá, mesa de centro com vaso em cima"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 800 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/bens-e-servicos-v2/banner-1280.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/bens-e-servicos-v2/banner-1280.png"
                              />
                              <img
                                src="assets/home24/banners/bens-e-servicos-v2/banner-1280.png"
                                alt="Sala com sofá, mesa de centro com vaso em cima"
                                className=""
                              />
                            </picture>
                          )}
                        </>
                      )}
                    </div>
                    <div className="conteudo-banner">
                      <h2 className="banner-title">
                        Realizar seus sonhos é mais fácil do que você imagina!
                      </h2>
                      <h3 className="banner-subtitle">
                        Facilitamos a aquisição do seu bem ou serviço com lojas parceiras em{' '}
                        <b>até 96x.</b>
                      </h3>
                      <p className="banner-saber-mais">Saiba mais</p>
                    </div>
                  </a>
                </div> */}
                <div className={`slide ${className}`}>
                  <a
                    href="https://fitenergia.com.br/financeira?int_source=portalSF&int_medium=home:carrossel:2a-dobra:fit-energia&int_campaign=quero-aderir"
                    target="_blank"
                    alt=""
                  >
                    <div className="bg-banner">
                      {typeof window === 'undefined' ? (
                        <></>
                      ) : (
                        <>
                          {width <= 312 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/fit-energia-v2/banner-312.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/fit-energia-v2/banner-312.png"
                              />
                              <img
                                src="assets/home24/banners/fit-energia-v2/banner-312.png"
                                alt="Rapaz sentado lendo sobre como aderir a Fit energia em um tablet"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 312 && width <= 414 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/fit-energia-v2/banner-414.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/fit-energia-v2/banner-414.png"
                              />
                              <img
                                src="assets/home24/banners/fit-energia-v2/banner-414.png"
                                alt="Rapaz sentado lendo sobre como aderir a Fit energia em um tablet"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 414 && width <= 600 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/fit-energia-v2/banner-601.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/fit-energia-v2/banner-601.png"
                              />
                              <img
                                src="assets/home24/banners/fit-energia-v2/banner-601.png"
                                alt="Rapaz sentado lendo sobre como aderir a Fit energia em um tablet"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 600 && width <= 800 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/fit-energia-v2/banner-800.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/fit-energia-v2/banner-800.png"
                              />
                              <img
                                src="assets/home24/banners/fit-energia-v2/banner-800.png"
                                alt="Rapaz sentado lendo sobre como aderir a Fit energia em um tablet"
                                className=""
                              />
                            </picture>
                          )}
                          {width > 800 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/fit-energia-v2/banner-1280.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/fit-energia-v2/banner-1280.png"
                              />
                              <img
                                src="assets/home24/banners/fit-energia-v2/banner-1280.png"
                                alt="Rapaz sentado lendo sobre como aderir a Fit energia em um tablet"
                                className=""
                              />
                            </picture>
                          )}
                        </>
                      )}
                    </div>
                    <div className="conteudo-banner">
                      <h2 className="banner-title">Economize até 15% na sua conta luz!</h2>
                      <h3 className="banner-subtitle">
                        Uma escolha inteligente começa por um consumo de energia limpa e mais
                        barata.
                      </h3>
                      <p className="banner-saber-mais">Quero aderir</p>
                    </div>
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a href="renegociacao-santander-financiamentos.html" alt="">
                    <div className="bg-banner">
                      {typeof window === 'undefined' ? (
                        <></>
                      ) : (
                        <>
                          {width <= 312 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/renegociacao-v2/banner-312.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/renegociacao-v2/banner-312.png"
                              />
                              <img
                                src="assets/home24/banners/renegociacao-v2/banner-312.png"
                                alt="Mulher realizando renegociação de dívida com parceiros da Santander Financiamentos."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 312 && width <= 414 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/renegociacao-v2/banner-414.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/renegociacao-v2/banner-414.png"
                              />
                              <img
                                src="assets/home24/banners/renegociacao-v2/banner-414.png"
                                alt="Mulher realizando renegociação de dívida com parceiros da Santander Financiamentos."
                                className=""
                              />
                            </picture>
                          )}
                          {/* {width > 414 && width <= 600 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/renegociacao-v2/banner-601.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/renegociacao-v2/banner-601.png"
                              />
                              <img
                                src="assets/home24/banners/renegociacao-v2/banner-601.png"
                                alt="Mulher realizando renegociação de dívida com parceiros da Santander Financiamentos."
                                className=""
                              />
                            </picture>
                          )} */}
                          {width > 414 && width <= 800 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/renegociacao-v2/banner-800.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/renegociacao-v2/banner-800.png"
                              />
                              <img
                                src="assets/home24/banners/renegociacao-v2/banner-800.png"
                                alt="Mulher realizando renegociação de dívida com parceiros da Santander Financiamentos."
                                className=""
                              />
                            </picture>
                          )}
                          {width > 800 && (
                            <picture>
                              <source
                                type="image/webp"
                                srcSet="assets/home24/banners/renegociacao-v2/banner-1280.webp"
                              />
                              <source
                                type="image/png"
                                srcSet="assets/home24/banners/renegociacao-v2/banner-1280.png"
                              />
                              <img
                                src="assets/home24/banners/renegociacao-v2/banner-1280.png"
                                alt="Mulher realizando renegociação de dívida com parceiros da Santander Financiamentos."
                                className=""
                              />
                            </picture>
                          )}
                        </>
                      )}
                    </div>
                    <div className="conteudo-banner">
                      <h2 className="banner-title">Negocie também com nossos parceiros!</h2>
                      <h3 className="banner-subtitle">
                        Você tem ainda mais opções para renegociar suas dívidas com facilidade e
                        segurança.
                      </h3>
                      <p className="banner-saber-mais">Renegociar</p>
                    </div>
                  </a>
                </div>
              </>
            )}
          </CustomEmblaCarouselHome24>
        </div>
      </ContainerHome24>

      <style jsx>{Styles}</style>
    </section>
  );
}

export default Home24Carousel;
